/**
 * Uses as response of ajax requests.
 * @see Ajax.post()
 */
class AjaxResponse {
  constructor() {
    this._done = [];
    this._fail = [];
    this._always = [];
  }

  done(callback) {
    this._done.push(callback);
    return this;
  }

  runDone(response) {
    for (const doneHandler of this._done) {
      doneHandler(response);
    }
  }

  fail(callback) {
    this._fail.push(callback);
    return this;
  }

  runFail(error) {
    for (const failHandler of this._fail) {
      failHandler(error);
    }
  }

  always(callback) {
    this._always.push(callback);
    return this;
  }

  runAlways() {
    for (const alwaysHandler of this._always) {
      alwaysHandler();
    }
  }
}

module.exports = AjaxResponse;
